import {Observer, Observable, Subject} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable()
export class WebSocketService {
  private subject: Subject<MessageEvent>;

  public connect(url): Subject<MessageEvent> {
    if (!this.subject) {
      this.subject = this.create(url);
    }

    return this.subject;
  }

  private create(url): Subject<MessageEvent> {
    let access_token = localStorage.getItem("LHP.access_token");
    // Use Sec-WebSocket-Protocol for passing access token as websocket
    // connectsion do not allow setting headers
    let ws = new WebSocket(url, ["authorization", access_token]);

    let observable = Observable.create((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);

      return ws.close.bind(ws);
    });

    let observer = {
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
      },
    };

    return Subject.create(observer, observable);
  }
}
